// extracted by mini-css-extract-plugin
module.exports = {"title":"GenerateLink_title__0_xSN","link":"GenerateLink_link__Ka3l7"};